import { BasicInsuranceModelType } from '../../../core/api';
import { SupplementaryInsuranceTypes } from '../../../core/states/offer/offer.state';
import { CampaignBasicInsurance, CampaignSupplementaryInsurance } from './campaign.product.types';

export const mapToBasicInsuranceModelType: {
  [key in CampaignBasicInsurance]: BasicInsuranceModelType;
} = {
  traditional: 'TRADITIONAL',
  managed_care_ham: 'MANAGED_CARE',
  managed_care: 'MANAGED_CARE',
  med_direct: 'MED_DIRECT',
  casa_nova: 'CASA_NOVA',
  tel_doc: 'TEL_DOC',
  med_call: 'MED_CALL',
  tel_care: 'TEL_CARE',
  combi_care: 'COMBI_CARE',
  viva: 'VIVA',
};

export const mapToSupplementaryInsuranceType: {
  [key in CampaignSupplementaryInsurance]: SupplementaryInsuranceTypes;
} = {
  complementary: 'complementary',
  outpatient: 'outpatient',
  hospital: 'hospital',
  basic: 'basic',
  hospital_capital: 'hospitalCapital',
  dental: 'dental',
  accident_disability_capital: 'accidentDisabilityCapital',
  accident_death_capital: 'accidentDeathCapital',
  sickness_death_or_disability_capital: 'sicknessDeathOrDisabilityCapital',
  daily_cash: 'dailyCash',
  hospital_daily_cash: 'hospitalDailyCash',
  legal_protection: 'legalProtection',
};
